export const defaultSpacing = {
	xxLarge: '32px',
	xLarge: '24px',
	large: '16px',
	medium: '12px',
	small: '8px',
	xSmall: '4px',
}
